<script setup lang="ts">
import { Github, LogOut, Mail, ShieldCheck, UserRound, WalletCards } from "lucide-vue-next"
import { useRouter } from "vue-router"

import { useSessionStore } from "../stores/session"

const session = useSessionStore()
const router = useRouter()

function providerName(provider: string): string {
  return provider === "github" ? "GitHub" : provider === "google" ? "Google" : provider
}

async function logout(): Promise<void> {
  await session.logout()
  await router.replace("/login")
}
</script>

<template>
  <section data-screen-label="账户">
    <div class="page-heading"><span class="eyebrow">Account</span><h1>账户</h1><p>当前产品身份和 Workspace 成员关系。</p></div>
    <div class="account-sheet">
      <div class="account-avatar">
        <img v-if="session.me?.avatar_url" :src="session.me.avatar_url" alt="" referrerpolicy="no-referrer" />
        <UserRound v-else :size="24" />
      </div>
      <div class="account-identity"><strong>{{ session.me?.display_name || session.me?.email.split('@')[0] }}</strong><span><Mail :size="14" />{{ session.me?.email }}</span></div>
      <span class="status-pill status-pill--active"><i></i>active</span>
    </div>
    <section class="account-credit-card" aria-label="额度余额">
      <header><span><WalletCards :size="17" />额度余额</span><small>CREDITS</small></header>
      <div>
        <article>
          <span>可用额度</span>
          <strong>{{ session.workspace?.credits.toLocaleString() ?? "—" }}</strong>
          <small>当前 Workspace</small>
        </article>
      </div>
    </section>
    <dl class="detail-list">
      <div><dt>Workspace</dt><dd>{{ session.workspace?.name }}</dd></div>
      <div><dt>角色</dt><dd>{{ session.workspace?.role }}</dd></div>
      <div><dt>套餐</dt><dd>Free</dd></div>
      <div><dt>登录安全</dt><dd><ShieldCheck :size="15" />{{ session.me?.email_verified ? "邮箱已验证" : "邮箱未验证" }} · HttpOnly Session</dd></div>
      <div>
        <dt>第三方账户</dt>
        <dd v-if="session.me?.oauth_providers.length" class="provider-list">
          <span v-for="provider in session.me.oauth_providers" :key="provider" class="provider-chip">
            <Github v-if="provider === 'github'" :size="13" />
            <span v-else-if="provider === 'google'" class="oauth-mark oauth-mark--small">G</span>
            {{ providerName(provider) }}
          </span>
        </dd>
        <dd v-else class="muted-copy">邮箱验证码</dd>
      </div>
    </dl>
    <div class="danger-zone"><div><strong>退出当前会话</strong><p>这不会吊销用于 Agent 调用的 API Keys。</p></div><button class="secondary-button" @click="logout"><LogOut :size="16" />退出登录</button></div>
  </section>
</template>
